import moment from 'moment';

import { createI18n } from 'vue-i18n';

import LocalizationsService from '@/services/LocalizationsService'
import EventBus from '@/services/EventBus.js';


const messages = { };

export const i18n = new createI18n({
  legacy: true, // <--- aktiviert den Kompatibilitätsmodus!
  locale: '',
  fallbackLocale: 'en-GB',
  messages,
  missingWarn: true,
// fallbackWarn: false ,
// fallbackWarn: /critical\..*/
});

export default i18n;

function setI18nLocalization(localizationId) {
  i18n.global.locale = localizationId;
  //axios.defaults.headers.common['Accept-Language'] = localizationId;
  document.querySelector('html').setAttribute('lang', localizationId);

  // Sets actual localization for localized date & time and number formats
  moment.locale(localizationId == 'deflt' ? 'en-GB' : localizationId);

  EventBus.$emit('LocalizationChanged', localizationId);

  return localizationId;
}

export function changeLocalization(localizationId, clientId) {
  // Fix 'de-at' to 'de-AT' etc.
  if (localizationId && localizationId.length === 5 && localizationId.includes('-')) {
    var textitem = _.split(localizationId, "-", 2);
    localizationId = textitem[0] + "-" + textitem[1].toUpperCase();
  }

  return LocalizationsService.getApplicationItemTexts(localizationId, clientId).then(
    response => {
      if (!_.isEmpty(response.data)) {
        i18n.global.setLocaleMessage(localizationId, response.data);
        return Promise.resolve(setI18nLocalization(localizationId));
      }
    }
  );
}
